<template>
        <span>
            <div v-for="(field, index) in fields" :key="index" v-if="!field.hidden" v-show="field.isVisible"
            :id="'question-' + field.form_key">

                <!-- Checkbox -->

                <LUCheckbox v-if="field.type === 'bool'" :question="question" :field="field" :index="index"
                            @visibilityChanged="visibilityChanged" @questionSelected="questionSelected"
                ></LUCheckbox>

                <div v-else class="row form-horizontal ">
                          <div :class="field.label ? 'col-12' : 'col-4' ">
                            <h2 v-if="field.order == 1" class="h5 position-relative" :class="{ 'field-error': field.hasError, 'required' : field.required === 1 }">
                                <strong><span class="number">{{ (questionNumber) + '. '}}</span> {{(question.question ? question.question : '')}}</strong>
                            </h2>
                          </div>
                          <div v-if="field.label" class="col-4 flex-group">
                            <label  :for="'form-' + field.form_key" class="control-label"
                                    :class="{ 'sr-only': !field.label, 'field-error-message': field.hasError, 'required' : field.required === 1 }">
                                    {{ (field.label  ? field.label : question.question) }}
                            </label>
                          </div>

                          <div class="col-8">
                            <div class="row" v-if="!field.hidden">
                                  <div class="form-group col-12 col-md-8">
                                    <!-- Tel -->
                                    <LUTelephone :question="question" :field="field" v-if="field.type === 'tel' && field.allow_multiple !== '1'"
                                            @visibilityChanged="visibilityChanged"  @questionSelected="questionSelected"
                                    ></LUTelephone>

                                    <!-- Email -->
                                    <LUEmail :question="question" :field="field" v-if="field.type === 'email' && field.allow_multiple !== '1'"
                                            @visibilityChanged="visibilityChanged"  @questionSelected="questionSelected"
                                    ></LUEmail>

                                    <!-- Text -->
                                    <LUText :question="question" :field="field" v-if="field.type === 'text' && field.allow_multiple !== '1'"
                                            @visibilityChanged="visibilityChanged"  @questionSelected="questionSelected"
                                    ></LUText>


                                    <!-- Toggle -->
                                    <LUToggle :question="question" :field="field" v-if="field.type === 'toggle'"
                                              @visibilityChanged="visibilityChanged"  @questionSelected="questionSelected"
                                    ></LUToggle>

                                    <!-- Number -->
                                    <LUNumber :question="question" :field="field" v-if="field.type === 'integer' && field.allow_multiple != '1'"
                                              @visibilityChanged="visibilityChanged"  @questionSelected="questionSelected"
                                    ></LUNumber>

                                    <!-- Checkbox (not a boolean as above -->
                                    <LUCheckbox v-if="field.type === 'checkbox'" :question="question" :field="field"
                                                @visibilityChanged="visibilityChanged"  @questionSelected="questionSelected"
                                    ></LUCheckbox>

                                    <!-- Date -->

                                    <LUDate :question="question" :field="field" :default="getAnswerValue(field.form_key)" v-if="field.type === 'date'"
                                            @visibilityChanged="visibilityChanged"  @questionSelected="questionSelected"
                                    ></LUDate>

                                    <LUTextarea v-if="field.type === 'textarea'" :field="field" :question="question"
                                                @visibilityChanged="visibilityChanged"  @questionSelected="questionSelected"
                                    ></LUTextarea>


                                    <LUSelectMultiple v-if="field.type=== 'multiple-choice-multiple'"  :field="field" :question="question"
                                                      @visibilityChanged="visibilityChanged"  @questionSelected="questionSelected">
                                    </LUSelectMultiple>

                                    <LUSelect v-if="field.type=== 'multiple-choice'"  :field="field" :question="question"
                                              @visibilityChanged="visibilityChanged"  @questionSelected="questionSelected">
                                    </LUSelect>

                                  </div>

                                </div>
                                 <p v-if="question.note" clas ="mb-0" :class="{ 'field-error-message': field.hasError }">
                                {{ question.note }}
                                </p>
                  </div>
                </div>
            </div>
        </span>
</template>
<script>
import LUCheckbox from './elements/Checkbox.vue'
import LUText from './elements/Text.vue'
import LUTelephone from './elements/Telephone.vue'
import LUEmail from './elements/Email.vue'
import LUTextarea from './elements/Textarea.vue'
import LUToggle from './elements/Toggle.vue'
import LUNumber from './elements/Number.vue'
import LUDate from './elements/Date.vue'
import LUSelect from './elements/Select.vue'
import LUSelectMultiple from './elements/SelectMultiple.vue'
import EventBus from '~/plugins/event-bus'
import { mapGetters } from 'vuex'

export default {
	name: 'Question',

	components: {
		LUCheckbox,
		LUText,
		LUTelephone,
		LUEmail,
		LUTextarea,
		LUToggle,
		LUNumber,
		LUDate,
		LUSelect,
		LUSelectMultiple
	},

	props: {
		question: {
			type: Object,
			default: {}
		},

		fields: {
			type: Array,
			default: []
		},

		questionNumber: {
			type: Number,
			default: 0
		},

		stepKey: {
			type: Number,
			default: 0
		},

		disabled: {
			type: Boolean
		}
	},

	data: () => ({
		errors: {},
		fieldArray: {},
		subfields: {},
		hours: [],
		occupation: [],
		isValidated: false,
		valid: false,
		isVisible: true,
		posTop: null,
		posBottom: null,
		updated: 0,
		day: '00',
		month: '00',
		year: '0000'
	}),

	created () {

    // this.validateInputs();
	},

	mounted () {
		this.$nextTick(() => {
			this.posTop = this.$el.getBoundingClientRect().top
			this.posBottom = this.$el.getBoundingClientRect().bottom
		})
	},

	watch: {
		stepKey: function (newValue, oldValue) {
      // update answer when we change question

			this.$forceUpdate()
      // this.answers = this.previousAnswer;

			this.setupFields()
			this.validateInputs()
		},
		question: {
			handler: function (val) {
				this.fields = val.fields
				this.$forceUpdate()
			},
			deep: true
		}
	},

	methods: {

		visibilityChanged: function (event) {
			const index = this.fields.findIndex(d => {
				return d.form_key === event.form_key
			})

			this.fields[index].isVisible = event.isVisible
		},

		questionSelected: function (questionId) {
			EventBus.$emit('questionSelected', questionId)
		},

		showQuestionIf: function (field) {
			consol
			if (field.required_if === null) {
				return true
			}

      // check answers for the required field type
      // if none - return false
			const answer = this.getAnswerValue(field.required_if)
			if (answer === '') {
				return false
			}
      // check the answer value matches the requirement value
			if (answer == field.required_if_value) {
				return true
			}
			return false
		},

		addSubfields (field, key, event) {
			this.answers[field.form_key] = this.answers[field.form_key] || []
			this.answers[field.form_key][key] = event.target.value
			this.$forceUpdate()
		},

		validateInputs: function (event) {
			const vm = this

			this.isValidated = true

			this.valid = true
			this.errors = {}

      // check all fields are valid
			this.fields.forEach(function (field) {
        // if ( !field.hasBeenChanged )
        //     return;
				vm.field.hasError = null

        // only validate fields that are visable
				if (!field.hidden) {
          // empty input
					if ((vm.answers[field.form_key] == '' || vm.answers[field.form_key] === undefined) && field.type !== 'checkbox') {
            // check if field is required
						if (field.required) {
							vm.field.hasError = 'This field cannot be left empty.'
							vm.valid = false
						}
					}
          // input has a value
					else {
            // check if there is an expected answer
						if (typeof field.answer === 'string') {
							if (field.answer.toLowerCase() != vm.answers[field.form_key].toLowerCase()) { // Not case-sensitive
								vm.field.hasError = 'Sorry, but you cannot proceed with that answer.'
								vm.valid = false
							}
						}

						if (field.type == 'email') {
							if (!vm.validEmail(vm.answers[field.form_key])) {
								vm.field.hasError = 'You must enter a valid email address.'
								vm.valid = false
							}
						} else if (field.type == 'date') {
							if (!vm.validDate(vm.answers[field.form_key], (typeof field.minAge !== 'undefined') ? field.minAge : false, (typeof field.maxAge !== 'undefined') ? field.maxAge : false)) {
								vm.field.hasError = 'You must enter a valid date.'
								vm.valid = false
							}
						} else if (field.type == 'tel') {
							if (!vm.validTelephone(vm.answers[field.form_key])) {
								vm.field.hasError = 'You must enter a valid telephone number.'
								vm.valid = false
							}
						} else if (field.type == 'postcode') {
							if (!vm.validPostcode(vm.answers[field.form_key])) {
								vm.field.hasError = 'You must enter a valid postcode.'
								vm.valid = false
							}
						} else if (field.type == 'integer') {
							if (!vm.validNumber(vm.answers[field.form_key])) {
								vm.field.hasError = 'You must enter a number.'
								vm.valid = false
							}
						}
					}
				}
			})
		},
		validEmail: function (value) {
			var re = /^[^@\s]+@[^@\s]+\.[^@\s]+$/
			return re.test(value)
		},

		validDate: function (value, minAge, maxAge) {
			var re = /^([0-9]{2})\/([0-9]{2})\/([0-9]{4})$/
			if (re.test(value)) {
				const sec = value.split('/')
				const day = sec[0]
				const month = sec[1]
				const year = sec[2]

				const d = new Date()

				if (maxAge ? year < d.getFullYear() - maxAge : year < 1908 || minAge ? (year > d.getFullYear() - minAge && month > d.getMonth() + 1) : year > d.getFullYear()) {
					return false
				}

				return true
			}
		},

		validTelephone: function (value) {
      // combined with optional country code and parantheses in between
			var re = /^(?:\+\d{1,3}|0\d{1,3}|00\d{1,2})?(?:\s?\(\d+\))?(?:[-\/\s.]|\d)+$/
			return re.test(value)
		},
		validPostcode: function (value) {
			var re = /^[A-Z]{1,2}[0-9]{1,2}[A-Z]{0,1} ?[0-9][A-Z]{2}$/i
			return re.test(value)
		},
		validNumber: function (value) {
			var re = /^\d*$/
			return re.test(parseInt(value))
		},
		setupFields: function () {
			const vm = this
			vm.question.fields.forEach((field, index) => {
				if (typeof field.isVisible === 'undefined') {
					vm.question.fields[index].isVisible = true
					field.isVisible = true
				}
				if (vm.question.fields[index].form_key == 'able-to-provide-landlord-permission') {
					vm.question.fields[index].hidden = !field.required_if_value
				}
				vm.question.fields[index].hidden = field.required_if_value
				field.hidden = field.required_if_value
			})
		},

		addField: function (field, index, event) {
			this.fields.push(field)
			this.$forceUpdate()
		},

		removeField: function (field, subfieldIndex, key) {
			delete this.answers[field.form_key + '-' + subfieldIndex]
			delete this.subfields[field.form_key][subfieldIndex]
			this.subfields[field.form_key].splice(subfieldIndex, 1)

			if (this.occupation.length > 0 || this.hours.length > 0) {
				this.occupation.splice(key, 1)
				this.hours.splice(key, 1)
			}

			this.validateInputs()
		},

		getAnswerValue: function (field) {
			const answer = this.$store.getters['form/getAnswerByKey'](field)
			if (answer !== undefined) {
				return answer.value
			}
			return ''
		}
	},

	computed: {
		...mapGetters({
			questions: 'form/questions',
			answers: 'form/answers'
		})
	}
}
</script>
<style>
.disabled{
    pointer-events: none;
    opacity: 0.4;
}
.checkbox label:after,
.radio label:after {
    content: '';
    display: table;
    clear: both;
}

.checkbox .cr,
.radio .cr {
    position: relative;
    display: inline-block;
    border: 1px solid #a9a9a9;
    border-radius: .25em;
    width: 1.3em;
    height: 1.3em;
    float: left;
    margin-right: .5em;
}

.radio .cr {
    border-radius: 50%;
}

.checkbox .cr .cr-icon,
.radio .cr .cr-icon {
    position: absolute !important;
    font-size: .8em;
    line-height: 0;
    top: 20%;
    left: 20%;
}

.radio .cr .cr-icon {
    margin-left: 0.04em;
}

.checkbox label input[type="checkbox"],
.radio label input[type="radio"] {
    display: none;
}

.checkbox label input[type="checkbox"] + .cr > .cr-icon,
.radio label input[type="radio"] + .cr > .cr-icon {

    opacity: 0;

}

.checkbox label input[type="checkbox"]:checked + .cr > .cr-icon,
.radio label input[type="radio"]:checked + .cr > .cr-icon {

    opacity: 1;
}

.checkbox label input[type="checkbox"]:disabled + .cr,
.radio label input[type="radio"]:disabled + .cr {
    opacity: .5;
}

  .field-error-input {
    border: solid 1px red;
  }

  .field-error > * {
    color: #ef7f7f !important;
  }

  .field-error-message {
    color: #ef7f7f !important;
  }
  .number {
    position: absolute;
    top: 0;
    left: -30px;
  }

 .flex-group {
    display: -webkit-flex;
    display: flex;
    -webkit-align-items: center;
    align-items: center;
  }

</style>




// WEBPACK FOOTER //
// resources/assets/js/frontend-vue/components/forms/question.vue